import {UserDetailObject} from './user-detail-object.model';
import {MainResponse} from './../../main-response.model';

export class UserDetailResponse extends MainResponse {
    object: UserDetailObject;

    constructor(obj = null) {
        super();
        obj = obj || {};

        this.init(obj);
        this.object = new UserDetailObject(obj.object);
    }
}
